import { useMutation } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { setSchemaAtom } from "../../../atoms/GlobalAtoms";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import TenantAPI from "../../api/TenantAPI";
import { DataTransforms, Schema } from "../../../types/TenantInterfaces";

interface Props {
  moduleAPIName: string;
  dataTransforms: DataTransforms;
  onSuccess: (newSchema: Schema) => void;
  onError: () => void;
}

const useCreateDataTransforms = () => {
  const setSchema = useSetAtom(setSchemaAtom);

  const createDataTransforms = useMutation({
    mutationFn: ({ moduleAPIName, dataTransforms }: Props) => {
      return TenantAPI.addDataTransforms(moduleAPIName, dataTransforms);
    },
    onSuccess: (data, { onSuccess }) => {
      const newSchema = data.data.data.schema;
      setSchema(newSchema);
      callFunctionIfExists(onSuccess, newSchema);
    },
  });

  return {
    createDataTransforms: createDataTransforms.mutate,
    loading: createDataTransforms.isPending,
    error: createDataTransforms.error
      ? getErrorMessage(createDataTransforms.error)
      : null,
  };
};

export default useCreateDataTransforms;
